import { environment } from '@app/../environments/environment';

import { BrowserModule } from '@angular/platform-browser';
import {NgModule, ErrorHandler, provideAppInitializer} from '@angular/core';

import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';

import { NgPipesModule } from 'ngx-pipes';

import { AuthInterceptor } from './_interceptor/auth.interceptor';

import { SettingsState } from './_state/settings.state';
import { TaskState } from './_state/task.state';

import { IconsProviderModule } from './icons-provider.module';

import { NZ_DATE_LOCALE, NZ_I18N, ru_RU } from 'ng-zorro-antd/i18n';

import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { ProjectState } from './_state/project.state';

import * as Sentry from '@sentry/angular';

import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { ProjectRolesState } from '@app/_state/project-roles.state';
import { AppPipesModule } from '@app/_pipes/app-pipes';
import { SharedModule } from '@app/_shared/shared.module';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NgChartsModule } from 'ng2-charts';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NavigationComponent } from '@app/navigation/navigation.component';
import { ru as RU } from 'date-fns/locale';
import { AppRoutingModule } from './app-routing.module';
import { Router } from '@angular/router';

registerLocaleData(ru);

@NgModule({ declarations: [
        // AppComponent,
    ],
    exports: [
        // NavigationComponent,
    ],
    bootstrap: [
      // AppComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NavigationComponent,
        NgxsModule.forRoot([SettingsState, TaskState, ProjectState, ProjectRolesState], { developmentMode: !environment.production }),
        NgxsStoragePluginModule.forRoot({
            keys: ['settings'],
        }),
        NgPipesModule,
        IconsProviderModule,
        SharedModule,
        NzLayoutModule,
        NzMenuModule,
        NzFormModule,
        NzInputModule,
        NzButtonModule,
        NzSpaceModule,
        NzCardModule,
        NzDividerModule,
        NzTableModule,
        NzPageHeaderModule,
        NzSelectModule,
        NzStatisticModule,
        NzDescriptionsModule,
        NzAlertModule,
        NzTypographyModule,
        NzTimelineModule,
        NzTagModule,
        NzListModule,
        NzModalModule,
        NzTabsModule,
        NzEmptyModule,
        NzCollapseModule,
        AppPipesModule,
        NgChartsModule,
        NzUploadModule,
        NzFlexModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: NZ_I18N,
            useValue: ru_RU,
        },
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: {
                dateFormat: 'dd.MM.yyyy HH:mm',
                // timezone: environment.defaultTimezone
            }
        },
        {
            provide: NZ_DATE_LOCALE,
            useValue: RU
        },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        AppComponent,
        provideHttpClient(withInterceptorsFromDi()),
    ],})
export class AppModule {}
